import { TokenCacheService } from '../services/token-cache.service';
import { AuthContext, detectAuthContext } from './auth-context.util';
import { readRoleClaim } from './jwt.util';

type TokenResolver = () => string | null;

/**
 * Token que viaja en las peticiones hechas desde la ruta `url`. Única fuente de esa
 * decisión: la usa el authInterceptor para firmar la petición, y las pantallas que
 * necesitan saber con qué ROL las va a juzgar el backend (un Owner operando el POS
 * viaja con el token del POS, no con el suyo).
 */
export function resolveRequestToken(url: string, tokenCache: TokenCacheService): string | null {
  const context = detectAuthContext(url);

  const contextTokenMap: Record<AuthContext, TokenResolver> = {
    pos: () => tokenCache.getPosToken(),
    'pos-simple': () => tokenCache.getPosToken(),
    kitchen: () => tokenCache.getKitchenToken(),
    bar: () => tokenCache.getBarToken(),
    waiter: () => tokenCache.getWaiterToken(),
    delivery: () => tokenCache.getDeliveryToken(),
    kiosk: () => null,
    owner: () => tokenCache.getAuthToken(),
    superadmin: () => tokenCache.getAuthToken(),
  };

  const token = contextTokenMap[context]();
  if (token) return token;

  return (
    tokenCache.getAuthToken() ||
    tokenCache.getPosToken() ||
    tokenCache.getKitchenToken() ||
    tokenCache.getBarToken() ||
    tokenCache.getWaiterToken() ||
    tokenCache.getDeliveryToken()
  );
}

/** Rol (claim del JWT) con el que el backend va a juzgar una petición hecha desde `url`. */
export function resolveRequestRole(url: string, tokenCache: TokenCacheService): string | null {
  return readRoleClaim(resolveRequestToken(url, tokenCache));
}
